import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

export default class Stepper extends Component {

  static propTypes = {
    active: PropTypes.string,
    onChange: PropTypes.func,
    steps: PropTypes.array,
  }

  getCurrIndex() {
    const currentStep = this.props.steps
      .find((step) => step.key === this.props.active)
    return this.props.steps.indexOf(currentStep)
  }

  @autobind
  handleNext() {
    const { steps, onChange } = this.props
    const nextIndex = this.getCurrIndex() + 1
    if (nextIndex < steps.length && onChange) {
      onChange({ target: { value: steps[nextIndex].key } })
    }
  }

  @autobind
  handlePrev() {
    const { steps, onChange } = this.props
    const nextIndex = this.getCurrIndex() - 1
    if (nextIndex >= 0 && onChange) {
      onChange({ target: { value: steps[nextIndex].key } })
    }
  }

  render() {

    const currIndex = this.getCurrIndex()

    const nextDisabled = currIndex >= this.props.steps.length - 1
    const prevDisabled = currIndex <= 0

    return (
      <div className="steps-stepper">
        <button
          className="action btn btn-default"
          type="button"
          disabled={prevDisabled}
          onClick={this.handlePrev}
        >
          Zurück
        </button>
        <button
          className="action btn btn-primary"
          type="button"
          disabled={nextDisabled}
          onClick={this.handleNext}
        >
          Weiter
        </button>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/Stepper.js